import { render, staticRenderFns } from "./RequiredDocuments.vue?vue&type=template&id=078a035e&scoped=true&"
import script from "./RequiredDocuments.vue?vue&type=script&lang=js&"
export * from "./RequiredDocuments.vue?vue&type=script&lang=js&"
import style0 from "./RequiredDocuments.vue?vue&type=style&index=0&id=078a035e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078a035e",
  null
  
)

export default component.exports